import { render, staticRenderFns } from "./BackofficeAutorizacao.vue?vue&type=template&id=19da469f&scoped=true"
import script from "./BackofficeAutorizacao.vue?vue&type=script&lang=ts"
export * from "./BackofficeAutorizacao.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeAutorizacao.vue?vue&type=style&index=0&id=19da469f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19da469f",
  null
  
)

export default component.exports